var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab flex-grow",class:{
    'partial-width':
      !_vm.isLastOddTab && !_vm.noTabClasses && (_vm.$mq === 'sm' || _vm.totalTabs > 3),
    'full-width':
      _vm.isLastOddTab && !_vm.noTabClasses && (_vm.$mq === 'sm' || _vm.totalTabs > 3)
  }},[_c('i',{class:_vm.iconClassName}),_c('span',{staticClass:"capitalize select-none"},[_vm._v(_vm._s(_vm.tabText))])])}
var staticRenderFns = []

export { render, staticRenderFns }